import Model from './Model';

export default class DailyAllowance extends Model {
  resource() {
    return 'daily-allowances';
  }
}
